import { combineReducers } from 'redux'

import { campaignProfile } from './campaign'
import { campaignListProfile } from './campaignList'

export const campaignReducer = combineReducers({
  campaignProfile,
  campaignListProfile
})
